// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CuratorCard_curator-card__AJxI4{
    width: 27vw;
    height: auto;
    border-radius: 2vw;
    display: flex;
    flex-direction: column;
}

.CuratorCard_curator-card-price-line__kD7fV{
    font-size: 1.6vw;
    margin-top: 0;
    margin-bottom: 0;
    color: #e65439;
    font-weight: 500;
    font-family: dm-sans-medium;
}

.CuratorCard_curator-card-trip-date__osrhA{
    font-size: 1.2vw;
    margin-top: 0.3vw;
    margin-bottom: 0;
    font-weight: 500;
    font-family: dm-sans-medium;
}

.CuratorCard_curator-card-curator-bg-img__\\+AvJt{
    width: 27vw;
    height: 12vw;
    object-fit: cover;
    position: absolute;
    margin-top: 5vw;
    border-radius: 1.5vw;
}

.CuratorCard_curator-card-curator-img__aUQEw{
    width: 12vw;
    height: 12vw;
    margin-top: 5vw;
    margin-left: 7.5vw;
    position: absolute;
}

.CuratorCard_curator-intro-name__bG83v{
    margin-top: 15vw;
    font-size: 1.4vw;
    margin-bottom: 0;
    width: 27vw;
    text-align: center;
    font-family: dm-sans-medium;
}

.CuratorCard_curator-intro-desc__XB9ob{
    font-size: 1.3vw;
    width: 27vw;
    /* word-spacing: 10px;     */
    text-align: justify;
}

@media(max-width: 768px){
    .CuratorCard_curator-card__AJxI4{
        width: 64vw;
        height: auto;
        border-radius: 2vw;
        display: flex;
        flex-direction: column;
    }
    
    .CuratorCard_curator-card-price-line__kD7fV{
        font-size: 4.2vw;
        margin-top: 0;
        margin-bottom: 0;
        color: #e65439;
        font-weight: 500;
    }
    
    .CuratorCard_curator-card-trip-date__osrhA{
        font-size: 3.5vw;
        margin-top: 0.3vw;
        margin-bottom: 0;
        font-weight: 500;
    }
    
    .CuratorCard_curator-card-curator-bg-img__\\+AvJt{
        width: 64vw;
        height: 30vw;
        object-fit: cover;
        position: absolute;
        margin-top:12vw;
        border-radius: 1.5vw;
    }
    
    .CuratorCard_curator-card-curator-img__aUQEw{
        width: 30vw;
        height: 30vw;
        margin-top: 12vw;
        margin-left: 17.5vw;
        position: absolute;
    }
    
    .CuratorCard_curator-intro-name__bG83v{
        margin-top: 35vw;
        font-size: 4vw;
        margin-bottom: 0;
        width: 64vw;
        text-align: center;
    }
    
    .CuratorCard_curator-intro-desc__XB9ob{
        font-size: 3.5vw;
        width: 64vw;
        /* word-spacing: 10px;     */
        text-align: justify;
        font-weight: 300;
        margin-bottom: 0vw;
        line-height: 5.5vw;
        margin-top: 2vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SingleTripPage/CuratorCard/CuratorCard.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IAEX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IAEZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QAEX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,gBAAgB;QAChB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,4BAA4B;QAC5B,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":[".curator-card{\n    width: 27vw;\n    display: flex;\n    height: auto;\n    border-radius: 2vw;\n    display: flex;\n    flex-direction: column;\n}\n\n.curator-card-price-line{\n    font-size: 1.6vw;\n    margin-top: 0;\n    margin-bottom: 0;\n    color: #e65439;\n    font-weight: 500;\n    font-family: dm-sans-medium;\n}\n\n.curator-card-trip-date{\n    font-size: 1.2vw;\n    margin-top: 0.3vw;\n    margin-bottom: 0;\n    font-weight: 500;\n    font-family: dm-sans-medium;\n}\n\n.curator-card-curator-bg-img{\n    width: 27vw;\n    height: 12vw;\n    margin-top: 1vw;\n    object-fit: cover;\n    position: absolute;\n    margin-top: 5vw;\n    border-radius: 1.5vw;\n}\n\n.curator-card-curator-img{\n    width: 12vw;\n    height: 12vw;\n    margin-top: 5vw;\n    margin-left: 7.5vw;\n    position: absolute;\n}\n\n.curator-intro-name{\n    margin-top: 15vw;\n    font-size: 1.4vw;\n    margin-bottom: 0;\n    width: 27vw;\n    text-align: center;\n    font-family: dm-sans-medium;\n}\n\n.curator-intro-desc{\n    font-size: 1.3vw;\n    width: 27vw;\n    /* word-spacing: 10px;     */\n    text-align: justify;\n}\n\n@media(max-width: 768px){\n    .curator-card{\n        width: 64vw;\n        display: flex;\n        height: auto;\n        border-radius: 2vw;\n        display: flex;\n        flex-direction: column;\n    }\n    \n    .curator-card-price-line{\n        font-size: 4.2vw;\n        margin-top: 0;\n        margin-bottom: 0;\n        color: #e65439;\n        font-weight: 500;\n    }\n    \n    .curator-card-trip-date{\n        font-size: 3.5vw;\n        margin-top: 0.3vw;\n        margin-bottom: 0;\n        font-weight: 500;\n    }\n    \n    .curator-card-curator-bg-img{\n        width: 64vw;\n        height: 30vw;\n        object-fit: cover;\n        position: absolute;\n        margin-top:12vw;\n        border-radius: 1.5vw;\n    }\n    \n    .curator-card-curator-img{\n        width: 30vw;\n        height: 30vw;\n        margin-top: 12vw;\n        margin-left: 17.5vw;\n        position: absolute;\n    }\n    \n    .curator-intro-name{\n        margin-top: 35vw;\n        font-size: 4vw;\n        margin-bottom: 0;\n        width: 64vw;\n        text-align: center;\n    }\n    \n    .curator-intro-desc{\n        font-size: 3.5vw;\n        width: 64vw;\n        /* word-spacing: 10px;     */\n        text-align: justify;\n        font-weight: 300;\n        margin-bottom: 0vw;\n        line-height: 5.5vw;\n        margin-top: 2vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"curator-card": `CuratorCard_curator-card__AJxI4`,
	"curator-card-price-line": `CuratorCard_curator-card-price-line__kD7fV`,
	"curator-card-trip-date": `CuratorCard_curator-card-trip-date__osrhA`,
	"curator-card-curator-bg-img": `CuratorCard_curator-card-curator-bg-img__+AvJt`,
	"curator-card-curator-img": `CuratorCard_curator-card-curator-img__aUQEw`,
	"curator-intro-name": `CuratorCard_curator-intro-name__bG83v`,
	"curator-intro-desc": `CuratorCard_curator-intro-desc__XB9ob`
};
export default ___CSS_LOADER_EXPORT___;
